module.exports = __webpack_public_path__ + "img/right.1cc7ea5e.png";